/*
 * @FileName       : Inventory.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/21/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : All the models for inventory reports.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

import { ResultSet } from '../common/result.set';

export class CsvDataObject {
	customer_name?: string;
	expiration?: string;
}

export class InventoryFilter {
	customer_id?: string;
	cabinet_id?: string;
	expiration?: string;
	product_label_name?: string;
	minibar_id?: string;
	minivax_id?: string;
	created_at?: any;
	cabinet_type?: string;
	lot?: string;
	paging?: any;
	option?: any;
	product_item_id?: string;
	order?: any;
}

export class InventoryErrorFilter {
	customer_id?: boolean;
	cabinet_id?: boolean;
	expiration?: boolean;
	product_item_id?: boolean;
	minibar_id?: boolean;
	minivax_id?: boolean;
	created_at?: boolean;
	cabinet_type?: boolean;
	lot?: boolean;
}

export interface InventoryGroup {
	product_item_id: string;
	product_label_name: string;
	total_count: number;
	total_in_transit: number;
}

export interface Inventory {
	customer_id: string;
	cabinet_id: string;
	product_item_id: string;
	minibar_id: number;
	minivax_id: number;
	expiration: string;
	created_at: Date;
}

export interface RecentlyVended {
	UTrx_Customer_ID?: string;
	UTrx_Product_Item_ID?: string;
	cabinet_type?: string;
	UTrx_Cabinet_ID?: string;
	UTrx_Type?: string;
	UTrx_Reason?: string;
	created_at?: any;
	expiration?: any;
	paging?: any;
}

export class InventoryDetail {
	product_item_id?: string;
	cabinet_type?: string;
	cabinet_id?: string;
	data?: ResultSet<Inventory>;

	constructor(item_id: string, cabinet_type: string, cabinet_id: string, result: ResultSet<Inventory>) {
		this.product_item_id = item_id;
		this.cabinet_type = cabinet_type;
		this.cabinet_id = cabinet_id;
		this.data = result;
	}
}

export class TransactionLogPayload {
	offset?: number = 0;
	limit?: number = 10;
	skip?: number;
	order?: any[];
	where?: any;
	fields?: object;
}
export class TransactionLogFilter {
	customerId?: string;
	lot?: string;
	productId?: string;
	productGroup?: string;
	cabinet_type?: string;
	cabinetId?: string;
	type?: string;
	reason?: string;
	date?: any;
	paging?: any;
	order?: any;
	option?: any;
	groupBy?: any;
	invNo?: any;
	serialNo?: any;
	tag?: string;
}

export class ReportFilter {
	history_date?: any;
	transaction_date?: any;
}
